import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import AppInside from './components/AppInside';
import DownloadCTA from './components/DownloadCTA';
import EsnafShowcase from './components/EsnafShowcase';
import Footer from './components/Footer';
import TanitimFilmi from './components/TanitimFilmi';
import Seo from '../../components/Seo';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Mahallebi - Komşunla Al, Komşunla Sat | Mahalle Bazlı Sosyal Ticaret"
        description="Mahallebi, mahalle bazlı sosyal ticaret uygulaması. Yakınındaki komşularınla ikinci el eşya al-sat, hizmet sun, ihtiyacını paylaş, acil durumda yardımlaş. Ücretsiz, Google Play ve App Store'da."
        path="/"
      />
      <Navigation />
      <Hero />
      <TanitimFilmi />
      <Features />
      <HowItWorks />
      <AppInside />
      <DownloadCTA />
      <EsnafShowcase />
      <Footer />
    </div>
  );
}